import { useTheme } from 'foundations-theming/utils';
import { Table } from 'foundations-components/transitional/components/Table';
import MeetingsTableHeader from './MeetingsTableHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GradientCell = () => {
  const trellisTheme = useTheme();
  return /*#__PURE__*/_jsx("div", {
    style: {
      maxWidth: '100%',
      height: '50%',
      background: `linear-gradient(to right, ${trellisTheme.color['do-not-use-gypsum']}, ${trellisTheme.color['do-not-use-koala']} 20%, ${trellisTheme.color['do-not-use-gypsum']} 40%)`,
      backgroundSize: 1200
    }
  });
};
const link = {
  name: 'skeleton'
};
const MeetingsLinksTableSkeleton = () => /*#__PURE__*/_jsxs(Table, {
  "data-selenium-test": "meetings-links-table-skeleton",
  children: [/*#__PURE__*/_jsx(MeetingsTableHeader, {}), /*#__PURE__*/_jsx("tbody", {
    children: Array(5).fill(null).map((_, i) => /*#__PURE__*/_jsxs("tr", {
      children: [/*#__PURE__*/_jsx("td", {
        children: /*#__PURE__*/_jsx(GradientCell, {})
      }, `${link.name}-name`), /*#__PURE__*/_jsx("td", {
        children: /*#__PURE__*/_jsx(GradientCell, {})
      }, `${link.name}-actions`), /*#__PURE__*/_jsx("td", {
        children: /*#__PURE__*/_jsx(GradientCell, {})
      }, `${link.name}-durations`), /*#__PURE__*/_jsx("td", {
        children: /*#__PURE__*/_jsx(GradientCell, {})
      }, `${link.name}-type`), /*#__PURE__*/_jsx("td", {
        children: /*#__PURE__*/_jsx(GradientCell, {})
      }, `${link.name}-views`), /*#__PURE__*/_jsx("td", {
        children: /*#__PURE__*/_jsx(GradientCell, {})
      }, `${link.name}-bookings`), /*#__PURE__*/_jsx("td", {
        children: /*#__PURE__*/_jsx(GradientCell, {})
      }, `${link.name}-conversions`)]
    }, i))
  })]
});
export default MeetingsLinksTableSkeleton;